export const FleetSubscriptionPlanTier = Object.freeze({
  RYD_FLEET_FREE: 'RYD_FLEET_FREE',
  RYD_FLEET_PLUS: 'RYD_FLEET_PLUS',
  RYD_FLEET_ENTERPRISE: 'RYD_FLEET_ENTERPRISE',
});

export type FleetSubscriptionPlanTierValue =
  (typeof FleetSubscriptionPlanTier)[keyof typeof FleetSubscriptionPlanTier];

export type FleetSubscriptionPlanMeta = {
  displayName: string;
  paid: boolean;
};

export const FLEET_SUBSCRIPTION_PLAN_META: Record<
  FleetSubscriptionPlanTierValue,
  FleetSubscriptionPlanMeta
> = {
  [FleetSubscriptionPlanTier.RYD_FLEET_FREE]: {
    displayName: 'ryd fleet free',
    paid: false,
  },
  [FleetSubscriptionPlanTier.RYD_FLEET_PLUS]: {
    displayName: 'ryd fleet plus',
    paid: true,
  },
  [FleetSubscriptionPlanTier.RYD_FLEET_ENTERPRISE]: {
    displayName: 'ryd fleet enterprise',
    paid: true,
  },
};

export function getFleetSubscriptionPlanMeta(planTier?: string): FleetSubscriptionPlanMeta | null {
  const normalizedTier = (planTier || '').trim().toUpperCase();
  if (!normalizedTier) {
    return null;
  }

  // Backward-compatible aliases for older stored values.
  const legacyToCurrentTierMap: Record<string, FleetSubscriptionPlanTierValue> = {
    FREE: FleetSubscriptionPlanTier.RYD_FLEET_FREE,
    PLUS: FleetSubscriptionPlanTier.RYD_FLEET_PLUS,
    ENTERPRISE: FleetSubscriptionPlanTier.RYD_FLEET_ENTERPRISE,
  };

  const mappedTier =
    (legacyToCurrentTierMap[normalizedTier] as FleetSubscriptionPlanTierValue) ||
    (normalizedTier as FleetSubscriptionPlanTierValue);

  return FLEET_SUBSCRIPTION_PLAN_META[mappedTier] || null;
}

export function getFleetSubscriptionPlanLabel(planTier?: string): string {
  return getFleetSubscriptionPlanMeta(planTier)?.displayName || planTier || '—';
}

export function hasPaidFleetSubscriptionPlan(planTier?: string): boolean {
  return getFleetSubscriptionPlanMeta(planTier)?.paid ?? false;
}
